<template>
  <div
    id="Usuario"
    v-if="$store.state.global_privilegio_admin_registro_usuario.ver"
  >
    <AdminMenu />
    <div class="row justify-content-md-center align-items-center">
      <div class="col-md-10">
        <div class="row container_admin">
          <!-- LISTA DE USUARIOS -->
          <div class="col-6 text-left mt-2">
            <b class="titulo">Usuarios</b>
          </div>
          <div class="col-6 d-flex justify-content-end mt-3">
            <button
              class="btn boton_guardar1"
              v-show="$store.state.global_privilegio_admin_registro_usuario.crear"
              data-toggle="modal"
              data-target="#myModal"
              type="button"
              style="margin-right: 3%"
            >
              <img
                class="icono mr-2"
                src="img/iconos/registro_usuario.png"
                alt="logo-color"
              />
              Nuevo Usuario
            </button>
          </div>
          <div class="col-12 table mt-3">
            <v-client-table
              class="col-md-12 mt-3"
              :columns="ct_clientes"
              :data="arrayUsuario"
              :options="options"
            >
              <div slot="privilegio" slot-scope="props">
                  <button
                    class="btn btn-block boton_copiado3"
                    v-if="
                      props.row.privilegio_usuario == '0' ||
                        props.row.privilegio_usuario == 'undefined'
                    "
                    data-toggle="modal"
                    data-target="#privilegiosUsuarios"
                    type="button"
                    @click="consultar_regional(props.row.id)"
                  >
                    Pendiente
                  </button>
                  <button
                    class="btn btn-block boton_copiado1"
                    v-if="
                      props.row.privilegio_usuario == '1' ||
                        props.row.privilegio_usuario == 'undefined'
                    "
                    data-toggle="modal"
                    data-target="#privilegios_editar"
                    type="button"
                    @click="consultar_privilegios(props.row.id)"
                  >
                    Establecido
                  </button>
              </div>
              <div slot="estado" slot-scope="props">
                  <button
                    class="btn btn-block boton_copiado2"
                    v-if="
                      props.row.estado_usuario == '0' ||
                        props.row.estado_usuario == 'undefined'
                    "
                    data-toggle="modal"
                    data-target="#estado_usuario"
                    type="button"
                    @click="consultar_id_cliente(props.row.id)"
                  >
                    Activo
                  </button>
                  <button
                    class="btn btn-block boton_copiado3"
                    v-if="
                      props.row.estado_usuario == '1' ||
                        props.row.estado_usuario == 'undefined'
                    "
                    data-toggle="modal"
                    data-target="#estado_usuario2"
                    type="button"
                    @click="consultar_id_cliente(props.row.id)"
                  >
                    No Activo
                  </button>
              </div>
              <div slot="opciones" slot-scope="props">
                  <button
                    class="btn dropdown-toggle boton_12"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  ></button>
                  <ul class="dropdown-menu b-dropdown-opt" role="menu">
                      <li>
                        <a
                          class="btn btn-block mi_boton"
                          v-show="
                            $store.state.global_privilegio_admin_registro_usuario
                              .editar
                          "
                          @click="consultarUsuario(props.row.id)"
                          >&nbsp;<b>Editar</b></a
                        >
                      </li>
                      <li>
                        <a
                          class="btn btn-block mi_boton"
                          data-toggle="modal"
                          data-target="#historial_usuario"
                          @click="consultar_historial(props.row.id)"
                          >&nbsp;<b>Historial</b></a
                        >
                      </li>
                      <li>
                        <a
                          class="btn btn-block mi_boton"
                          data-toggle="modal"
                          data-target="#auditoriaUsuario"
                          @click="
                            auditoriaUsuarioConsulta(props.row.correo);
                            auditoriaUsuarioDescarga(props.row.correo);
                          "
                          >&nbsp;<b>Verificación C&D</b></a
                        >
                      </li>
                      <li>
                        <a
                          class="btn btn-block mi_boton"
                          v-show="
                            $store.state.global_privilegio_admin_registro_usuario
                              .eliminar
                          "
                          @click="eliminar_usuario(props.row.id)"
                          >&nbsp;<b>Eliminar</b></a
                        >
                      </li>
                  </ul>
              </div>
            </v-client-table>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL AGREGAR USUARIO -->
    <div
      class="modal fade"
      id="myModal"
      tabindex="-1"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title dato" id="myModalLabel">Datos generales</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form method="post" @submit.prevent="registroUsuario()">
              <div class="box-body row">
                <div class="col-md-4">
                  <label class="color_letra">Nombre *:</label>
                  <input
                    class="form-control boton_texto"
                    v-model="usuario.u_nombre_usuario"
                    type="text"
                    @keyup="
                      usuario.u_nombre_usuario = usuario.u_nombre_usuario.replace(
                        /\b\w/g,
                        (l) => l.toUpperCase()
                      )
                    "
                    placeholder="Nombres"
                    required
                  />
                </div>
                <div class="col-md-4">
                  <label class="color_letra">Apellido *:</label>
                  <input
                    class="form-control boton_texto"
                    v-model="usuario.u_apellido"
                    type="text"
                    @keyup="
                      usuario.u_apellido = usuario.u_apellido.replace(
                        /\b\w/g,
                        (l) => l.toUpperCase()
                      )
                    "
                    placeholder="Apellidos"
                    required
                  />
                </div>
                <div class="col-md-4">
                  <label class="color_letra">Cédula *:</label>
                  <input
                    class="form-control boton_texto"
                    v-model="usuario.u_cedula"
                    type="number"
                    placeholder="C.C"
                    required
                  />
                </div>
                <div class="col-md-4">
                  <label class="color_letra mt-3">Cargo:</label>
                  <input
                    class="form-control boton_texto"
                    v-model="usuario.u_cargo"
                    type="text"
                    @keyup="
                      usuario.u_cargo = usuario.u_cargo.replace(/\b\w/g, (l) =>
                        l.toUpperCase()
                      )
                    "
                    placeholder="Cargo"
                  />
                </div>
                <div class="col-md-4">
                  <label class="color_letra mt-3">Correo *:</label>
                  <input
                    class="form-control boton_texto"
                    v-model.trim="usuario.u_correo"
                    type="email"
                    @keyup="usuario.u_correo = usuario.u_correo.toLowerCase()"
                    placeholder="Correo electrónico"
                    required
                  />
                </div>
                <div class="col-md-4">
                  <label class="color_letra mt-3">Celular:</label>
                  <input
                    class="form-control boton_texto"
                    v-model.number="usuario.u_telefono"
                    type="number"
                    placeholder="Número de celular"
                  /><br />
                </div>
                <div class="col-md-12">
                  <label class="color_letra">* Campos Obligatorios.</label>
                </div>
                <div class="col-md-12 mt-3">
                  <button class="btn btn_guardar btn-block" type="submit">
                    <b>Guardar</b>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL PRIVILEGIOS -->
    <div
      class="modal fade"
      id="privilegiosUsuarios"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-xl modal-dialog-scrollable"
        role="document"
      >
        <div class="modal-content container_admin">
          <div class="modal-body">
            <h3 class="titulo p-2" id="exampleModalLabel">
              Privilegios del Usuario
            </h3>
            <ul class="nav nav-tabs mt-4" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="pm-tab"
                  data-toggle="tab"
                  href="#pm"
                  role="tab"
                  aria-controls="pm"
                  aria-selected="true"
                  >Por Módulos</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="ptd-tab"
                  data-toggle="tab"
                  href="#ptd"
                  role="tab"
                  aria-controls="ptd"
                  aria-selected="false"
                  >Por Tipos de Datos</a
                >
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div
                class="tab-pane fade show active mt-3"
                id="pm"
                role="tabpanel"
                aria-labelledby="pm-tab"
              >
                <div class="row">
                  <div class="col-md-5">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="custom-control custom-switch">
                          <input
                            class="custom-control-input"
                            type="checkbox"
                            id="admin"
                            v-model="adminPrivilegio"
                          />
                          <label
                            class="custom-control-label parrafos"
                            for="admin"
                          >
                            Administración
                          </label>
                        </div>
                      </div>
                      <div class="col-md-12" v-if="adminPrivilegio">
                        <div class="row ml-3">
                          <div class="col-md-12">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="adminCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_cliente.ver
                              "
                              @click="selectCliente()"
                            />
                            <label class="form-check-label" for="adminCliente"
                              >Registro de clientes</label
                            >
                          </div>
                          <div
                            class="col-md-12 ml-2"
                            v-if="
                              u_privilegios_iper.m_administracion
                                .registro_cliente.ver
                            "
                          >
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="crearCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_cliente.crear
                              "
                            />
                            <label class="form-check-label" for="crearCliente"
                              >Crear</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="editarCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_cliente.editar
                              "
                            />
                            <label class="form-check-label" for="editarCliente"
                              >Editar</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="eliminarCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_cliente.eliminar
                              "
                            />
                            <label
                              class="form-check-label"
                              for="eliminarCliente"
                              >Eliminar</label
                            >
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 mt-2" v-if="adminPrivilegio">
                        <div class="row ml-3">
                          <div class="col-md-12">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="adminCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_proceso.ver
                              "
                              @click="selectProceso()"
                            />
                            <label class="form-check-label" for="adminCliente"
                              >Registro de procesos</label
                            >
                          </div>
                          <div
                            class="col-md-12 ml-2"
                            v-if="
                              u_privilegios_iper.m_administracion
                                .registro_proceso.ver
                            "
                          >
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="crearCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_proceso.crear
                              "
                            />
                            <label class="form-check-label" for="crearCliente"
                              >Crear</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="editarCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_proceso.editar
                              "
                            />
                            <label class="form-check-label" for="editarCliente"
                              >Editar</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="eliminarCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_proceso.eliminar
                              "
                            />
                            <label
                              class="form-check-label"
                              for="eliminarCliente"
                              >Eliminar</label
                            >
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 mt-2" v-if="adminPrivilegio">
                        <div class="row ml-3">
                          <div class="col-md-12">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="adminCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_peligro.ver
                              "
                              @click="selectPeligro()"
                            />
                            <label class="form-check-label" for="adminCliente"
                              >Registro de peligros</label
                            >
                          </div>
                          <div
                            class="col-md-12 ml-2"
                            v-if="
                              u_privilegios_iper.m_administracion
                                .registro_peligro.ver
                            "
                          >
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="crearCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_peligro.crear
                              "
                            />
                            <label class="form-check-label" for="crearCliente"
                              >Crear</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="editarCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_peligro.editar
                              "
                            />
                            <label class="form-check-label" for="editarCliente"
                              >Editar</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="eliminarCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_peligro.eliminar
                              "
                            />
                            <label
                              class="form-check-label"
                              for="eliminarCliente"
                              >Eliminar</label
                            >
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 mt-2" v-if="adminPrivilegio">
                        <div class="row ml-3">
                          <div class="col-md-12">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="adminCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_control_medida.ver
                              "
                              @click="selectControl()"
                            />
                            <label class="form-check-label" for="adminCliente"
                              >Control existente o medida de intervención</label
                            >
                          </div>
                          <div
                            class="col-md-12 ml-2"
                            v-if="
                              u_privilegios_iper.m_administracion
                                .registro_control_medida.ver
                            "
                          >
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="crearCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_control_medida.crear
                              "
                            />
                            <label class="form-check-label" for="crearCliente"
                              >Crear</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="editarCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_control_medida.editar
                              "
                            />
                            <label class="form-check-label" for="editarCliente"
                              >Editar</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="eliminarCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_control_medida.eliminar
                              "
                            />
                            <label
                              class="form-check-label"
                              for="eliminarCliente"
                              >Eliminar</label
                            >
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 mt-2" v-if="adminPrivilegio">
                        <div class="row ml-3">
                          <div class="col-md-12">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="adminCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_usuario.ver
                              "
                              @click="selectUsuario()"
                            />
                            <label class="form-check-label" for="adminCliente"
                              >Registro de usuario</label
                            >
                          </div>
                          <div
                            class="col-md-12 ml-2"
                            v-if="
                              u_privilegios_iper.m_administracion
                                .registro_usuario.ver
                            "
                          >
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="crearCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_usuario.crear
                              "
                            />
                            <label class="form-check-label" for="crearCliente"
                              >Crear</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="editarCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_usuario.editar
                              "
                            />
                            <label class="form-check-label" for="editarCliente"
                              >Editar</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="eliminarCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_usuario.eliminar
                              "
                            />
                            <label
                              class="form-check-label"
                              for="eliminarCliente"
                              >Eliminar</label
                            >
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 mt-2" v-if="adminPrivilegio">
                        <div class="row ml-3">
                          <div class="col-md-12">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="adminCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_regionales.ver
                              "
                              @click="selectRegionales()"
                            />
                            <label class="form-check-label" for="adminCliente"
                              >Registro de regionales</label
                            >
                          </div>
                          <div
                            class="col-md-12 ml-2"
                            v-if="
                              u_privilegios_iper.m_administracion
                                .registro_regionales.ver
                            "
                          >
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="crearCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_regionales.crear
                              "
                            />
                            <label class="form-check-label" for="crearCliente"
                              >Crear</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="editarCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_regionales.editar
                              "
                            />
                            <label class="form-check-label" for="editarCliente"
                              >Editar</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="eliminarCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_regionales.eliminar
                              "
                            />
                            <label
                              class="form-check-label"
                              for="eliminarCliente"
                              >Eliminar</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="custom-control custom-switch">
                          <input
                            class="custom-control-input"
                            type="checkbox"
                            id="matrizPeligro"
                            v-model="matrizPrivilegio"
                          />
                          <label
                            class="custom-control-label parrafos"
                            for="matrizPeligro"
                          >
                            Matriz Peligro
                          </label>
                        </div>
                      </div>
                      <div class="col-md-12" v-if="matrizPrivilegio">
                        <div class="row ml-3">
                          <div class="col-md-12">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="matrcesPeligro"
                              v-model="u_privilegios_iper.m_matriz_peligro.ver"
                              @click="selectMatrices()"
                            />
                            <label class="form-check-label" for="matrcesPeligro"
                              >Matrices de Peligros</label
                            >
                          </div>
                          <div
                            class="col-md-12 ml-2"
                            v-if="u_privilegios_iper.m_matriz_peligro.ver"
                          >
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="crearCliente"
                              v-model="
                                u_privilegios_iper.m_matriz_peligro.consultar
                              "
                            />
                            <label class="form-check-label" for="crearCliente"
                              >Consultar</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="crearCliente"
                              v-model="
                                u_privilegios_iper.m_matriz_peligro.crear
                              "
                            />
                            <label class="form-check-label" for="crearCliente"
                              >Crear</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="editarCliente"
                              v-model="
                                u_privilegios_iper.m_matriz_peligro.editar
                              "
                            />
                            <label class="form-check-label" for="editarCliente"
                              >Editar</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="eliminarCliente"
                              v-model="
                                u_privilegios_iper.m_matriz_peligro.eliminar
                              "
                            />
                            <label
                              class="form-check-label"
                              for="eliminarCliente"
                              >Eliminar</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="eliminarCliente"
                              v-model="
                                u_privilegios_iper.m_matriz_peligro
                                  .descargar_excel
                              "
                            />
                            <label
                              class="form-check-label"
                              for="eliminarCliente"
                              >Descargar excel</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="eliminarCliente"
                              v-model="
                                u_privilegios_iper.m_matriz_peligro
                                  .copiar_matriz
                              "
                            />
                            <label
                              class="form-check-label"
                              for="eliminarCliente"
                              >Copiar matriz</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="eliminarCliente"
                              v-model="
                                u_privilegios_iper.m_matriz_peligro
                                  .control_cambios
                              "
                            />
                            <label
                              class="form-check-label"
                              for="eliminarCliente"
                              >Control de Cambio</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="eliminarCliente"
                              v-model="
                                u_privilegios_iper.m_matriz_peligro
                                  .verificacion_cyd
                              "
                            />
                            <label
                              class="form-check-label"
                              for="eliminarCliente"
                              >Verificación C&D</label
                            >
                          </div>
                          <div class="col-md-12 mt-2">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="adminCliente"
                              v-model="u_regionales_todas"
                            />
                            <label class="form-check-label" for="adminCliente"
                              >Todas las matrices</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="custom-control custom-switch">
                          <input
                            class="custom-control-input"
                            type="checkbox"
                            id="consulta"
                            v-model="consultaPrivilegio"
                          />
                          <label
                            class="custom-control-label parrafos"
                            for="consulta"
                          >
                            Consulta
                          </label>
                        </div>
                      </div>
                      <div class="col-md-12" v-if="consultaPrivilegio">
                        <div class="row ml-3">
                          <div class="col-md-12">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="consultar"
                              v-model="u_privilegios_iper.m_consulta.ver"
                            />
                            <label class="form-check-label" for="consultar"
                              >Consultar</label
                            >
                          </div>
                          <div
                            class="col-md-12 ml-2"
                            v-if="u_privilegios_iper.m_consulta.ver == true"
                          >
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="matrcesPeligro"
                              v-model="u_privilegios_iper.m_consulta.excel"
                            />
                            <label class="form-check-label" for="matrcesPeligro"
                              >Descarar excel</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="matrcesPeligro"
                              v-model="u_privilegios_iper.m_consulta.pdf"
                            />
                            <label class="form-check-label" for="matrcesPeligro"
                              >Descarar Pdf</label
                            >
                          </div>
                          <div class="col-md-12">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="consultar"
                              v-model="fechaInicio"
                            />
                            <label class="form-check-label" for="consultar"
                              >Fecha</label
                            >
                          </div>
                          <div class="col-md-12" v-if="fechaInicio">
                            <label>Desde</label>
                            <input
                              type="date"
                              class="form-control"
                              v-model="u_rango_fecha_inicio"
                            />
                            <label>Hasta</label>
                            <input
                              type="date"
                              class="form-control"
                              v-model="u_rango_fecha_fin"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 mt-4">
                    <div class="row">
                      <div class="col-md-6">
                        <button
                          class="btn btn_guardar btn-block"
                          type="button"
                          @click="agregar_privilegio(usuario.uid_usuario)"
                        >
                          Guardar
                        </button>
                      </div>
                      <div class="col-md-6">
                        <button
                          class="btn btn_cancelar btn-block"
                          type="button"
                          data-dismiss="modal"
                        >
                          Cancelar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade"
                id="ptd"
                role="tabpanel"
                aria-labelledby="ptd-tab"
              >
                <br />
                <div class="col-md-12">
                  <input
                    v-model="regional"
                    type="radio"
                    value="Todas las Regionales"
                  />
                  Todas las regionales<br />
                  <input
                    v-model="regional"
                    type="radio"
                    value="Regionales a seleccionar"
                  />
                  Regionales<br />
                  <br />
                </div>
                <div
                  class="row"
                  v-show="regional == 'Regionales a seleccionar'"
                >
                  <div class="col-md-12 ml-3">
                    <div
                      v-for="(item_usuario, index) in arrayRegionales"
                      :key="index.item_usuario"
                    >
                      <input
                        v-model="regionales_list"
                        data-toggle="collapse"
                        type="radio"
                        :href="'#collapse-' + index"
                        @change="departamentos_select"
                        role="button"
                        aria-expanded="true"
                        aria-controls="collapseExample"
                        :value="item_usuario.regionalConsultada"
                      />
                      {{ item_usuario.regionalConsultada }}

                      <div class="collapse" :id="'collapse-' + index">
                        <div class="col-md-12 ml-4">
                          <br />
                          <label class="ml-3"><b>Departamentos</b></label
                          ><br />

                          <input
                            class="form-check-input"
                            v-model="todos_departamentos"
                            type="checkbox"
                          />
                          Todos los departamentos
                          <div
                            v-for="(item_departa, indexx) in filtro_departa(
                              departamento_general,
                              item_usuario.regionalConsultada
                            )"
                            :key="indexx.item_departa"
                          >
                            <input
                              v-model="item_departa.checked"
                              data-toggle="collapse"
                              type="checkbox"
                              :href="'#collapsee-' + indexx"
                              @change="municipio_departamento"
                              role="button"
                              aria-expanded="false"
                              aria-controls="collapseExample1"
                            />
                            {{ item_departa.departamento_list }}

                            <div class="collapse" :id="'collapsee-' + indexx">
                              <br />
                              <label class="ml-3"><b>Municipios</b></label
                              ><br />
                              <input
                                class="ml-3"
                                id="checkMain"
                                v-model="todos_municipios"
                                type="checkbox"
                                onclick="checkMain"
                              />
                              Todos los municipios
                              <div
                                v-for="(municipio, indexxx) of filtro_municipio(
                                  municipio_general,
                                  item_departa.departamento_list
                                )"
                                :key="indexxx.municipio"
                                class="ml-3"
                              >
                                <input
                                  class="checkAll"
                                  v-model="municipio.checked"
                                  type="checkbox"
                                />
                                {{ municipio.nombre }}
                              </div>
                              <br />
                            </div>
                          </div>
                        </div>
                        <br />
                        <button
                          class="btn boton_guardar"
                          type="button"
                          @click="add_reg()"
                        >
                          Agregar Regional</button
                        ><br />
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="regional == 'Todas las Regionales'">
                  <button
                    class="btn boton_guardar"
                    type="button"
                    @click="consultarRegionales()"
                  >
                    Guardarr
                  </button>
                </div>
                <div class="col-md-12 text-right">
                  <button class="btn btn-secondary" type="button">
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL PRIVILEGIOS REGISTRO -->
    <div
      class="modal fade"
      id="privilegiosUsuariosRegistro"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-xl modal-dialog-scrollable"
        role="document"
      >
        <div class="modal-content container_admin">
          <div class="modal-body">
            <h3 class="titulo p-2" id="exampleModalLabel">
              Privilegios del Usuario {{ usuario.u_nombre_usuario }}
              {{ usuario.u_apellido }}
            </h3>
            <ul class="nav nav-tabs mt-4" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="pm-tab"
                  data-toggle="tab"
                  href="#pm"
                  role="tab"
                  aria-controls="pm"
                  aria-selected="true"
                  >Por Módulos</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="ptd-tab"
                  data-toggle="tab"
                  href="#ptd"
                  role="tab"
                  aria-controls="ptd"
                  aria-selected="false"
                  >Por Tipos de Datos</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL EDITAR USUARIO -->
    <div
      class="modal fade"
      id="editarusuario"
      data-backdrop="static"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content container_admin">
          <div class="modal-body">
            <h3 class="dato w-100 font-weight-bold" id="exampleModalLabel">
              Datos usuarios
            </h3>
            <form
              method="post"
              @submit.prevent="historialUsuarioEditado(usuario.uid_usuario)"
            >
              <div class="box-body row">
                <div class="col-md-4">
                  <label class="color_letra mt-3">Nombres *:</label>
                  <input
                    class="form-control boton_texto"
                    v-model="usuario.u_nombre_usuario"
                    type="text"
                    @keyup="
                      usuario.u_nombre_usuario = usuario.u_nombre_usuario.replace(
                        /\b\w/g,
                        (l) => l.toUpperCase()
                      )
                    "
                    placeholder="Nombres"
                    required
                  />
                </div>
                <div class="col-md-4">
                  <label class="color_letra mt-3">Apellidos *:</label>
                  <input
                    class="form-control boton_texto"
                    v-model="usuario.u_apellido"
                    type="text"
                    @keyup="
                      usuario.u_apellido = usuario.u_apellido.replace(
                        /\b\w/g,
                        (l) => l.toUpperCase()
                      )
                    "
                    placeholder="Apellidos"
                    required
                  />
                </div>
                <div class="col-md-4">
                  <label class="color_letra mt-3">Cédula *:</label>
                  <input
                    class="form-control boton_texto"
                    v-model="usuario.u_cedula"
                    type="number"
                    placeholder="C.C"
                    required
                  />
                </div>
                <div class="col-md-4">
                  <label class="color_letra mt-3">Cargo:</label>
                  <input
                    class="form-control boton_texto"
                    v-model="usuario.u_cargo"
                    type="text"
                    @keyup="
                      usuario.u_cargo = usuario.u_cargo.replace(/\b\w/g, (l) =>
                        l.toUpperCase()
                      )
                    "
                    placeholder="Cargo"
                    required
                  />
                </div>
                <div class="col-md-4">
                  <label class="color_letra mt-3">Correo *:</label>
                  <input
                    class="form-control boton_texto"
                    v-model.trim="usuario.u_correo"
                    type="email"
                    @keyup="usuario.u_correo = usuario.u_correo.toLowerCase()"
                    placeholder="Correo electrónico"
                    required
                  />
                </div>
                <div class="col-md-4">
                  <label class="color_letra mt-3">Celular:</label>
                  <input
                    class="form-control boton_texto"
                    v-model.number="usuario.u_telefono"
                    type="number"
                    placeholder="Número de celular"
                  /><br />
                </div>
                <div class="col-md-6">
                  <button type="submit" class="btn btn_guardar btn-block">
                    <b>Guardar</b>
                  </button>
                </div>
                <div class="col-md-6">
                  <button
                    class="btn btn_cancelar btn-block"
                    type="button"
                    data-dismiss="modal"
                    @click="vaciasVariables()"
                  >
                    <b>Cancelar</b>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL CAMBIO DE ESTADO USUARIO NO ACTIVO -->
    <div
      class="modal fade"
      id="estado_usuario"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content container_admin">
          <div class="modal-body text-center">
            <div class="row">
              <div class="col-md-12">
                <h4 class="dato font-weight-bold">
                  Confirmación cambio de estado
                </h4>
              </div>
              <div class="col-md-12">
                <p class="parrafos">
                  Al confirmar, este usuario pasará automáticamente al estado
                  <b>No Activo</b>. El usuario no podrá acceder a la aplicación.
                </p>
              </div>
              <div class="col-md-6">
                <button
                  class="btn btn_guardar btn-block"
                  type="button"
                  @click="historial_usuario_estado(usuario.uid_usuario)"
                >
                  <b>Confirmar</b>
                </button>
              </div>
              <div class="col-md-6">
                <button
                  class="btn btn_cancelar btn-block"
                  data-dismiss="modal"
                  type="button"
                >
                  <b>Cancelar</b>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL CAMBIO DE ESTADO USUARIO ACTIVO -->
    <div
      class="modal fade"
      id="estado_usuario2"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content container_admin">
          <div class="modal-body text-center">
            <div class="row">
              <div class="col-md-12">
                <h4 class="dato font-weight-bold">
                  Confirmación cambio de estado
                </h4>
              </div>
              <div class="col-md-12">
                <p class="parrafos">
                  Al confirmar, este usuario pasará automáticamente al estado
                  <b>Activo</b>. El usuario podrá acceder a la aplicación.
                </p>
              </div>
              <div class="col-md-6">
                <button
                  class="btn btn_guardar btn-block"
                  type="button"
                  @click="historial_usuario_estado1(usuario.uid_usuario)"
                >
                  <b>Confirmar</b>
                </button>
              </div>
              <div class="col-md-6">
                <button
                  class="btn btn_cancelar btn-block"
                  data-dismiss="modal"
                  type="button"
                >
                  <b>Cancelar</b>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL HISTORIAL -->
    <div
      class="modal fade"
      id="historial_usuario"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content container_admin">
          <div class="modal-body">
            <h3 class="dato h4"><b>Historial del Usuario</b></h3>
            <ul
              class="nav nav-pills mb-3 justify-content-center"
              id="pills-tab"
              role="tablist"
            >
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="historial-modificado-tab"
                  data-toggle="pill"
                  href="#historial-modificado"
                  role="tab"
                  aria-controls="historial-modificado"
                  aria-selected="true"
                  style="color: #e8640c"
                  >Modificado</a
                >
              </li>
              &nbsp;&nbsp;
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="historial-creado-tab"
                  data-toggle="pill"
                  href="#historial-creado"
                  role="tab"
                  aria-controls="historial-creado"
                  aria-selected="false"
                  style="color: #e8640c"
                  >Creado</a
                >
              </li>
              &nbsp;&nbsp;
            </ul>
            <div class="tab-content" id="pills-tabContent">
              <div
                class="tab-pane fade show active"
                id="historial-modificado"
                role="tabpanel"
                aria-labelledby="historial-modificado-tab"
              >
                <div class="table table-responsive">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th scope="col">Nombre Completo</th>
                        <th scope="col">Cédula</th>
                        <th scope="col">Cargo</th>
                        <th scope="col">Correo</th>
                        <th scope="col">Celular</th>
                        <th scope="col">Privilegios</th>
                        <th scope="col">Estado</th>
                        <th scope="col">Fecha</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item6, index) of array_historial"
                        :key="index.item6"
                      >
                        <td>{{ item6.usuario }} {{ item6.apellido }}</td>
                        <td>{{ item6.cedula }}</td>
                        <td>{{ item6.cargo }}</td>
                        <td>{{ item6.correo }}</td>
                        <td>{{ item6.celular }}</td>
                        <td v-if="item6.privilegios == '0'">Pendiente</td>
                        <td v-else-if="item6.privilegios == '1'">
                          Establecido
                        </td>
                        <td v-if="item6.estado == '0'">Activo</td>
                        <td v-else-if="item6.estado == '1'">No Activo</td>
                        <td>
                          {{ item6.fecha_historial }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div
                class="tab-pane fade"
                id="historial-creado"
                role="tabpanel"
                aria-labelledby="historial-creado-tab"
              >
                <div class="table table-responsive">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th scope="col">Nombre Completo</th>
                        <th scope="col">Cédula</th>
                        <th scope="col">Cargo</th>
                        <th scope="col">Correo</th>
                        <th scope="col">Celular</th>
                        <th scope="col">Estado</th>
                        <th scope="col">Fecha</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item7, index) of array_historial"
                        :key="index.item7"
                      >
                        <td>{{ item7.usuario }} {{ item7.apellido }}</td>
                        <td>{{ item7.cedula }}</td>
                        <td>{{ item7.cargo }}</td>
                        <td>{{ item7.correo }}</td>
                        <td>{{ item7.celular }}</td>
                        <td v-if="item7.estado == '0'">Activo</td>
                        <td v-else-if="item7.estado == '1'">No Activo</td>
                        <td>
                          {{ item7.fecha_registro }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <button
              class="btn btn_guardar btn-block"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL PRIVILEGIOS EDITAR-->
    <div
      class="modal fade"
      id="privilegios_editar"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-xl modal-dialog-scrollable"
        role="document"
      >
        <div class="modal-content container_admin">
          <div class="modal-body">
            <h3 class="titulo p-2" id="exampleModalLabel">
              Privilegios del Usuario {{ usuario.u_nombre_usuario }}
              {{ usuario.u_apellido }}
            </h3>
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="pmm-tab"
                  data-toggle="tab"
                  href="#pmm"
                  role="tab"
                  aria-controls="pmm"
                  aria-selected="true"
                  >Por Módulos</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="por_datos-tab"
                  data-toggle="tab"
                  href="#por_datos"
                  role="tab"
                  aria-controls="por_datos"
                  aria-selected="false"
                  >Por Tipos de Datos</a
                >
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div
                class="tab-pane fade show active mt-3"
                id="pmm"
                role="tabpanel"
                aria-labelledby="pmm-tab"
              >
                <div class="row">
                  <div class="col-md-5">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="custom-control custom-switch">
                          <label class="custom-control-label parrafos">
                            Administración
                          </label>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="row ml-3">
                          <div class="col-md-12">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="adminCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_cliente.ver
                              "
                              @click="selectCliente()"
                            />
                            <label class="form-check-label" for="adminCliente"
                              >Registro de clientes</label
                            >
                          </div>
                          <div
                            class="col-md-12 ml-2"
                            v-if="
                              u_privilegios_iper.m_administracion
                                .registro_cliente.ver
                            "
                          >
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="crearCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_cliente.crear
                              "
                            />
                            <label class="form-check-label" for="crearCliente"
                              >Crear</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="editarCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_cliente.editar
                              "
                            />
                            <label class="form-check-label" for="editarCliente"
                              >Editar</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="eliminarCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_cliente.eliminar
                              "
                            />
                            <label
                              class="form-check-label"
                              for="eliminarCliente"
                              >Eliminar</label
                            >
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 mt-2">
                        <div class="row ml-3">
                          <div class="col-md-12">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="adminCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_proceso.ver
                              "
                              @click="selectProceso()"
                            />
                            <label class="form-check-label" for="adminCliente"
                              >Registro de procesos</label
                            >
                          </div>
                          <div
                            class="col-md-12 ml-2"
                            v-if="
                              u_privilegios_iper.m_administracion
                                .registro_proceso.ver
                            "
                          >
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="crearCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_proceso.crear
                              "
                            />
                            <label class="form-check-label" for="crearCliente"
                              >Crear</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="editarCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_proceso.editar
                              "
                            />
                            <label class="form-check-label" for="editarCliente"
                              >Editar</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="eliminarCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_proceso.eliminar
                              "
                            />
                            <label
                              class="form-check-label"
                              for="eliminarCliente"
                              >Eliminar</label
                            >
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 mt-2">
                        <div class="row ml-3">
                          <div class="col-md-12">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="adminCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_peligro.ver
                              "
                              @click="selectPeligro()"
                            />
                            <label class="form-check-label" for="adminCliente"
                              >Registro de peligros</label
                            >
                          </div>
                          <div
                            class="col-md-12 ml-2"
                            v-if="
                              u_privilegios_iper.m_administracion
                                .registro_peligro.ver
                            "
                          >
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="crearCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_peligro.crear
                              "
                            />
                            <label class="form-check-label" for="crearCliente"
                              >Crear</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="editarCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_peligro.editar
                              "
                            />
                            <label class="form-check-label" for="editarCliente"
                              >Editar</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="eliminarCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_peligro.eliminar
                              "
                            />
                            <label
                              class="form-check-label"
                              for="eliminarCliente"
                              >Eliminar</label
                            >
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 mt-2">
                        <div class="row ml-3">
                          <div class="col-md-12">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="adminCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_control_medida.ver
                              "
                              @click="selectControl()"
                            />
                            <label class="form-check-label" for="adminCliente"
                              >Control existente o medida de intervención</label
                            >
                          </div>
                          <div
                            class="col-md-12 ml-2"
                            v-if="
                              u_privilegios_iper.m_administracion
                                .registro_control_medida.ver
                            "
                          >
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="crearCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_control_medida.crear
                              "
                            />
                            <label class="form-check-label" for="crearCliente"
                              >Crear</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="editarCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_control_medida.editar
                              "
                            />
                            <label class="form-check-label" for="editarCliente"
                              >Editar</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="eliminarCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_control_medida.eliminar
                              "
                            />
                            <label
                              class="form-check-label"
                              for="eliminarCliente"
                              >Eliminar</label
                            >
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 mt-2">
                        <div class="row ml-3">
                          <div class="col-md-12">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="adminCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_usuario.ver
                              "
                              @click="selectUsuario()"
                            />
                            <label class="form-check-label" for="adminCliente"
                              >Registro de usuario</label
                            >
                          </div>
                          <div
                            class="col-md-12 ml-2"
                            v-if="
                              u_privilegios_iper.m_administracion
                                .registro_usuario.ver
                            "
                          >
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="crearCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_usuario.crear
                              "
                            />
                            <label class="form-check-label" for="crearCliente"
                              >Crear</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="editarCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_usuario.editar
                              "
                            />
                            <label class="form-check-label" for="editarCliente"
                              >Editar</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="eliminarCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_usuario.eliminar
                              "
                            />
                            <label
                              class="form-check-label"
                              for="eliminarCliente"
                              >Eliminar</label
                            >
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 mt-2">
                        <div class="row ml-3">
                          <div class="col-md-12">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="adminCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_regionales.ver
                              "
                              @click="selectRegionales()"
                            />
                            <label class="form-check-label" for="adminCliente"
                              >Registro de regionales</label
                            >
                          </div>
                          <div
                            class="col-md-12 ml-2"
                            v-if="
                              u_privilegios_iper.m_administracion
                                .registro_regionales.ver
                            "
                          >
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="crearCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_regionales.crear
                              "
                            />
                            <label class="form-check-label" for="crearCliente"
                              >Crear</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="editarCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_regionales.editar
                              "
                            />
                            <label class="form-check-label" for="editarCliente"
                              >Editar</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="eliminarCliente"
                              v-model="
                                u_privilegios_iper.m_administracion
                                  .registro_regionales.eliminar
                              "
                            />
                            <label
                              class="form-check-label"
                              for="eliminarCliente"
                              >Eliminar</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="custom-control custom-switch">
                          <label class="custom-control-label parrafos">
                            Matriz Peligro
                          </label>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="row ml-3">
                          <div class="col-md-12">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="matrcesPeligro"
                              v-model="u_privilegios_iper.m_matriz_peligro.ver"
                              @click="selectMatrices()"
                            />
                            <label class="form-check-label" for="matrcesPeligro"
                              >Matrices de Peligros</label
                            >
                          </div>
                          <div
                            class="col-md-12 ml-2"
                            v-if="u_privilegios_iper.m_matriz_peligro.ver"
                          >
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="crearCliente"
                              v-model="
                                u_privilegios_iper.m_matriz_peligro.consultar
                              "
                            />
                            <label class="form-check-label" for="crearCliente"
                              >Consultar</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="crearCliente"
                              v-model="
                                u_privilegios_iper.m_matriz_peligro.crear
                              "
                            />
                            <label class="form-check-label" for="crearCliente"
                              >Crear</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="editarCliente"
                              v-model="
                                u_privilegios_iper.m_matriz_peligro.editar
                              "
                            />
                            <label class="form-check-label" for="editarCliente"
                              >Editar</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="eliminarCliente"
                              v-model="
                                u_privilegios_iper.m_matriz_peligro.eliminar
                              "
                            />
                            <label
                              class="form-check-label"
                              for="eliminarCliente"
                              >Eliminar</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="eliminarCliente"
                              v-model="
                                u_privilegios_iper.m_matriz_peligro
                                  .descargar_excel
                              "
                            />
                            <label
                              class="form-check-label"
                              for="eliminarCliente"
                              >Descargar excel</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="eliminarCliente"
                              v-model="
                                u_privilegios_iper.m_matriz_peligro
                                  .copiar_matriz
                              "
                            />
                            <label
                              class="form-check-label"
                              for="eliminarCliente"
                              >Copiar matriz</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="eliminarCliente"
                              v-model="
                                u_privilegios_iper.m_matriz_peligro
                                  .control_cambios
                              "
                            />
                            <label
                              class="form-check-label"
                              for="eliminarCliente"
                              >Control de Cambio</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="eliminarCliente"
                              v-model="
                                u_privilegios_iper.m_matriz_peligro
                                  .verificacion_cyd
                              "
                            />
                            <label
                              class="form-check-label"
                              for="eliminarCliente"
                              >Verificación C&D</label
                            >
                          </div>
                          <div class="col-md-12 mt-2">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="adminCliente"
                              v-model="u_regionales_todas"
                            />
                            <label class="form-check-label" for="adminCliente"
                              >Todas las matrices</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="custom-control custom-switch">
                          <label class="custom-control-label parrafos">
                            Consulta
                          </label>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="row ml-3">
                          <div class="col-md-12">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="consultar"
                              v-model="u_privilegios_iper.m_consulta.ver"
                            />
                            <label class="form-check-label" for="consultar"
                              >Consultar</label
                            >
                          </div>
                          <div
                            class="col-md-12 ml-2"
                            v-if="u_privilegios_iper.m_consulta.ver == true"
                          >
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="matrcesPeligro"
                              v-model="u_privilegios_iper.m_consulta.excel"
                            />
                            <label class="form-check-label" for="matrcesPeligro"
                              >Descarar excel</label
                            ><br />
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="matrcesPeligro"
                              v-model="u_privilegios_iper.m_consulta.pdf"
                            />
                            <label class="form-check-label" for="matrcesPeligro"
                              >Descarar Pdf</label
                            >
                          </div>
                          <div class="col-md-12">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="consultar"
                              v-model="fechaInicio"
                            />
                            <label class="form-check-label" for="consultar"
                              >Fecha</label
                            >
                          </div>
                          <div class="col-md-12" v-if="fechaInicio">
                            <label>Desde</label>
                            <input
                              type="date"
                              class="form-control"
                              v-model="u_rango_fecha_inicio"
                            />
                            <label>Hasta</label>
                            <input
                              type="date"
                              class="form-control"
                              v-model="u_rango_fecha_fin"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <button
                      class="btn btn_guardar btn-block"
                      type="button"
                      @click="editar_privilegio"
                    >
                      Guardar</button
                    ><br />
                  </div>
                  <div class="col-md-6">
                    <button
                      class="btn btn_cancelar btn-block"
                      type="button"
                      data-dismiss="modal"
                    >
                      Cancelar</button
                    ><br />
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade"
                id="por_datos"
                role="tabpanel"
                aria-labelledby="por_datos-tab"
              >
                <br />
                <div class="col-md-12">
                  <input v-model="p_regional" type="radio" value="false" />
                  Todas las Regionales<br />
                  <input v-model="p_regional" type="radio" value="true" />
                  Regionales<br />
                  <br />
                </div>
                <div class="row">
                  <p
                    class="ml-4"
                    style="
                      margin-bottom: -20px !important;
                      color: gray !important;
                    "
                  >
                    Regionales seleccionadas para el usuario:
                  </p>
                  <p
                    class="ml-4"
                    style="
                      margin-bottom: -7px !important;
                      color: gray !important;
                    "
                    v-for="item_regional in regionales1"
                    :key="item_regional.id"
                  >
                    "{{ item_regional.regionales_select }}",
                  </p>
                  <div class="col-md-12 ml-3 mt-4">
                    <div
                      v-for="(item_usuario_editar, index) in regional_general2"
                      :key="index.item_usuario_editar"
                    >
                      <input
                        v-model="regionales_list"
                        data-toggle="collapse"
                        type="radio"
                        :href="'#collapse-' + index"
                        role="button"
                        aria-expanded="false"
                        aria-controls="collapseExample"
                        @change="departamentos_editar(this.p_key)"
                        :value="item_usuario_editar.regionalConsultada"
                      />
                      {{ item_usuario_editar.regionalConsultada }}

                      <div class="collapse" :id="'collapse-' + index">
                        <div class="col-md-12 ml-4">
                          <br />
                          <label class="ml-3"><b>Departamentos</b></label
                          ><br />

                          <input
                            class="form-check-input"
                            v-model="todos_departamentos"
                            type="checkbox"
                          />
                          Todos los departamentos
                          <div
                            v-for="(item_departamento,
                            indexx) in filtro_departa(
                              departamento_general_editar,
                              item_usuario_editar.regionalConsultada
                            )"
                            :key="indexx.item_departamento"
                          >
                            <input
                              v-model="lista_departamentos"
                              data-toggle="collapse"
                              type="checkbox"
                              role="button"
                              aria-expanded="false"
                              aria-controls="collapseExample1"
                              @change="municipio_consulta(lista_departamentos)"
                              :value="
                                item_departamento.departamento_list_editar
                              "
                            />
                            {{ item_departamento.departamento_list_editar }}
                            <br />

                            <label class="ml-4"><b>Municipios</b></label
                            ><br />
                            <div
                              v-for="municipio1 of filtro_municipio_editar(
                                municipio_general,
                                item_departamento.departamento_list_editar
                              )"
                              :key="municipio1"
                              class="ml-4"
                            >
                              <input
                                class="form-check-input"
                                v-model="lista_municipios"
                                type="checkbox"
                                :value="municipio1.nombre"
                              />
                              {{ municipio1.nombre }}
                            </div>
                            <br />
                          </div>
                        </div>
                        <br />
                        <button
                          class="btn boton_guardar"
                          type="button"
                          @click="consultarUsuario()"
                        >
                          Agregar Regional</button
                        ><br />
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="p_regional == 'false'">
                  <button
                    class="btn boton_guardar"
                    type="button"
                    @click="consultarUsuario()"
                  >
                    Guardar
                  </button>
                </div>
                <div class="col-md-12 text-right">
                  <button
                    class="btn btn-secondary"
                    data-dismiss="modal"
                    type="button"
                  >
                    Cerrar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- FIN MODAL PRIVILEGIOS EDITAR-->

    <!-- MODAL VERIFICACIÓN C&D -->
    <div
      class="modal fade"
      id="auditoriaUsuario"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content container_admin">
          <div class="modal-header">
            <h5 class="modal-title dato" id="exampleModalLabel">
              VERIFICACIÓN C&D
            </h5>
            <button
              class="close"
              data-dismiss="modal"
              type="button"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <nav>
              <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <button
                  class="nav-link active"
                  id="nav-home-tab"
                  data-toggle="tab"
                  data-target="#nav-home"
                  type="button"
                  role="tab"
                  aria-controls="nav-home"
                  aria-selected="true"
                >
                  Consulta
                </button>
                <button
                  class="nav-link"
                  id="nav-profile-tab"
                  data-toggle="tab"
                  data-target="#nav-profile"
                  type="button"
                  role="tab"
                  aria-controls="nav-profile"
                  aria-selected="false"
                >
                  Descarga
                </button>
              </div>
            </nav>
            <div class="tab-content" id="nav-tabContent">
              <div
                class="tab-pane fade show active"
                id="nav-home"
                role="tabpanel"
                aria-labelledby="nav-home-tab"
              >
                <table
                  class="table"
                  v-if="data_historial_consulta.length != ''"
                >
                  <thead class="cabezalTable">
                    <tr>
                      <th scope="col">Centro Trabajo</th>
                      <th scope="col">Ciudad</th>
                      <th scope="col">Departamento</th>
                      <th scope="col">Regional</th>
                      <th scope="col">Fecha</th>
                    </tr>
                  </thead>
                  <tbody
                    v-for="matriz_consulta of data_historial_consulta"
                    :key="matriz_consulta.id"
                  >
                    <tr>
                      <td>{{ matriz_consulta.centroTrabajo }}</td>
                      <td>{{ matriz_consulta.ciudad }}</td>
                      <td>{{ matriz_consulta.departamento }}</td>
                      <td>{{ matriz_consulta.regional }}</td>
                      <td>{{ matriz_consulta.registro }}</td>
                    </tr>
                  </tbody>
                </table>
                <div
                  class="alert alert-warning"
                  role="alert"
                  v-if="data_historial_consulta.length === 0"
                >
                  No hay registros de Historial de Consulta para este
                  <b>Usuario</b>.
                </div>
              </div>
              <div
                class="tab-pane fade"
                id="nav-profile"
                role="tabpanel"
                aria-labelledby="nav-profile-tab"
              >
                <table
                  class="table"
                  v-if="data_historial_descarga.length != ''"
                >
                  <thead class="cabezalTable">
                    <tr>
                      <th scope="col">Centro Trabajo</th>
                      <th scope="col">Ciudad</th>
                      <th scope="col">Departamento</th>
                      <th scope="col">Regional</th>
                      <th scope="col">Fecha</th>
                    </tr>
                  </thead>
                  <tbody
                    v-for="matriz_descarga of data_historial_descarga"
                    :key="matriz_descarga.id"
                  >
                    <tr>
                      <td>{{ matriz_descarga.centroTrabajo }}</td>
                      <td>{{ matriz_descarga.ciudad }}</td>
                      <td>{{ matriz_descarga.departamento }}</td>
                      <td>{{ matriz_descarga.regional }}</td>
                      <td>{{ matriz_descarga.registro }}</td>
                    </tr>
                  </tbody>
                </table>
                <div
                  class="alert alert-warning"
                  role="alert"
                  v-if="data_historial_descarga.length === 0"
                >
                  No hay registros de Historial de Descarga para este
                  <b>Usuario</b>.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="alert alert-warning" role="alert" v-else>
    No tiene permiso para ver el Módulo
  </div>
</template>

<script>
// IMPORTACIÓN DE FIREBASE
import { firebase, auth, db } from "@/firebase";
// IMPORTACIÓN DE SWEET ALERT
import Swal from "sweetalert2";
import AdminMenu from "@/components/AdminMenu.vue";
import moment from "moment";

export default {
  name: "Usuario",
  components: {
    AdminMenu,
  },

  data() {
    return {
      // VARIABLES TABLA USUARIOS
      arrayUsuario: [],
      ct_clientes: [
        "nombre",
        "apellido",
        "cedula",
        "cargo",
        "correo",
        "privilegio",
        "estado",
        "opciones",
      ],
      options: {
        headings: {
          nombre: "Nombre",
          apellido: "Apellidos",
          cedula: "Cédula",
          cargo: "Cargo",
          correo: "Correo",
          privilegio: "Privilegios",
          estado: "Estado",
          opciones: "Opciones",
        },
        sortable: ["nombre", "apellido", "cedula", "cargo", "correo"],
        texts: {
          filter: "Buscar",
          filterPlaceholder: "",
        },
      },
      usuario: {
        uid_usuario: "",
        u_nombre_usuario: "",
        u_apellido: "",
        u_cedula: "",
        u_cargo: "",
        u_correo: "",
        u_telefono: "",
        u_privilegios: "0",
        u_estado: "0",
        registro_fecha: firebase.firestore.FieldValue.serverTimestamp(),
        u_registrado_por: "",
        u_contraseña: "",
      },

      adminPrivilegio: false,
      matrizPrivilegio: false,
      consultaPrivilegio: false,
      fechaInicio: false,
      matricesRegional: false,

      // VARIABLES PRIVILEGIOS
      u_privilegios_iper: {
        m_administracion: {
          registro_cliente: {
            crear: false,
            editar: false,
            eliminar: false,
            ver: false,
          },
          registro_control_medida: {
            crear: false,
            editar: false,
            eliminar: false,
            ver: false,
          },
          registro_efectos: {
            crear: false,
            editar: false,
            eliminar: false,
            ver: false,
          },
          registro_peligro: {
            crear: false,
            editar: false,
            eliminar: false,
            ver: false,
          },
          registro_proceso: {
            crear: false,
            editar: false,
            eliminar: false,
            ver: false,
          },
          registro_regionales: {
            crear: false,
            editar: false,
            eliminar: false,
            ver: false,
          },
          registro_usuario: {
            crear: false,
            editar: false,
            eliminar: false,
            ver: false,
          },
        },
        m_consulta: {
          excel: false,
          pdf: false,
          ver: false,
        },
        m_matriz_peligro: {
          ver: false,
          descargar_excel: false,
          editar: false,
          crear: false,
          copiar_matriz: false,
          eliminar: false,
          consultar: false,
          control_cambios: false,
          verificacion_cyd: false,
        },
      },
      u_rango_fecha_inicio: "",
      u_rango_fecha_fin: "",
      u_regionales_todas: false,
      u_matrices_regional: [],

      // REGIONAL - DEPARTAMENTO - MUNICIPIO
      arrayRegionales: [],
      arrayRegionales1: [],

      regional_general2: [],
      regionales: [],
      regionales1: [],
      municipio_general: [],
      departamento_general: [],
      departamento_general_editar: [],
      array_historial: [],

      // PRUEBA
      id_regionales: "",
      regional: "",
      lista_regionales: [],
      lista_municipios: [],
      lista_departamentos: [],

      municipios: [],
      departamento: "",
      regional: [],
      todos_municipios: false,
      todos_departamentos: false,
      municipio_check: [],
      departamento_list: [],
      regionales_list: "",

      // VARIABLES CONSULTAR REGIONALES PRIVILEGIOS
      p_regional: true,

      regionales_sub: "",

      query_regional: "",
      array_reg_edit: [],
      municipiosSele: [],

      arrayUpdate: [],
      todas_seleccionada_regional: false,
      p_todas_seleccionada_regional: "",

      /* AUDITORÍA */
      data_historial_consulta: [],
      data_historial_descarga: [],
    };
  },

  created() {
    if (this.$store.state.global_privilegio_admin_registro_usuario.ver) {
      this.tabla_usuario();
    }
  },

  methods: {
    // FECHAS
    inicio_etapa() {
      setTimeout(() => {
        this.texto_fin = "";
        var opciones = "";
        var opciones = document.getElementById("fecha_inicial").value;
        if (opciones != "") {
          document.getElementById("fecha_final").setAttribute("min", opciones);
        }
      }, 200);
    },

    // TABLA DE USUARIO
    async tabla_usuario() {
      /* INICIAR LOADING */
      this.$isLoading(true);

      if (this.arrayUsuario.length > 0) {
      } else {
        this.arrayUsuario = [];
        db.collection("usuarios")
          .orderBy("u_nombre_usuario", "desc")
          .onSnapshot((snapshot) => {
            let changes = snapshot.docChanges();
            changes.forEach((change) => {
              if (change.type === "added") {
                this.arrayUsuario.unshift({
                  id: change.doc.id,
                  nombre: change.doc.data().u_nombre_usuario,
                  apellido: change.doc.data().u_apellido,
                  cedula: change.doc.data().u_cedula,
                  cargo: change.doc.data().u_cargo,
                  correo: change.doc.data().u_correo,
                  telefono: change.doc.data().u_telefono,
                  privilegio_usuario: change.doc.data().u_privilegios,
                  estado_usuario: change.doc.data().u_estado,
                });
              } else if (change.type === "modified") {
                for (let index = 0; index < this.arrayUsuario.length; index++) {
                  if (change.doc.id == this.arrayUsuario[index].id) {
                    this.arrayUsuario.splice(index, 1);
                  }
                }
                this.arrayUsuario.unshift({
                  id: change.doc.id,
                  nombre: change.doc.data().u_nombre_usuario,
                  apellido: change.doc.data().u_apellido,
                  cedula: change.doc.data().u_cedula,
                  cargo: change.doc.data().u_cargo,
                  correo: change.doc.data().u_correo,
                  telefono: change.doc.data().u_telefono,
                  privilegio_usuario: change.doc.data().u_privilegios,
                  estado_usuario: change.doc.data().u_estado,
                });
              } else if (change.type === "removed") {
                for (let index = 0; index < this.arrayUsuario.length; index++) {
                  if (change.doc.id == this.arrayUsuario[index].id) {
                    this.arrayUsuario.splice(index, 1);
                  }
                }
              } else {
              }
            });
          });
      }
      /* FINALIZAR LOADING */
      this.$isLoading(false);
    },

    // FUNCIÓN PARA AGREGAR A LA BASE DE DATOS USUARIOS
    registroUsuario() {
      /* INICIAR LOADING */
      // this.$isLoading(true);
      $("#myModal").modal("hide");

      this.usuario.u_contraseña = this.usuario.u_cedula;
      this.usuario.u_registrado_por = this.$store.state.email;
      // FIREBASE AUTHENTICATION
      auth
        .createUserWithEmailAndPassword(
          this.usuario.u_correo,
          this.usuario.u_cedula
        )
        .then((credencial) => {
          this.usuario.uid_usuario = credencial.user.uid;
          credencial.user.sendEmailVerification().then(() => {
            // GUARDAR REGISTRO DE USUARIO
            const saveUser = db
              .collection("usuarios")
              .doc(this.usuario.uid_usuario);
            saveUser
              .set(this.usuario)
              .then(() => {})
              .catch((error) => {
                firebase
                  .auth()
                  .currentUser.delete()
                  .then(() => {
                    // AVISO POR CONSOLA
                    console.info("Usuario eliminado: ", error);
                  })
                  .catch((error) => {
                    // AVISO AL USUARIO DEL ERROR
                    console.info("Error al eliminar usuario: ", error);
                  });
                // AVISO AL USUARIO DEL ERROR
                console.info("Error al guardar el usuario: ", error);
              });
            this.agregar_historial(this.usuario.uid_usuario);
            // this.datos_registro_modal(this.usuario.uid_usuario);
            /* INICIAR LOADING */
            // this.$isLoading(false);
          });
        })
        .catch((error) => {
          //AVISO AL USUARIO DEL ERROR
          console.info("Error al autentificar usuario: ", error);
        });
    },

    agregar_historial(id_usuario) {
      this.hora_registro_historial = firebase.firestore.FieldValue.serverTimestamp();
      const newHistorial = db.collection("historial_usuario").doc();
      const id_historial = newHistorial.id;
      db.collection("historial_usuario")
        .doc(id_historial)
        .set({
          // DATOS DEL CLIENTE
          hu_idHisotrial: id_historial,
          hu_id_usuario: id_usuario,
          hu_nombre_usuario: this.usuario.u_nombre_usuario,
          hu_apellido: this.usuario.u_apellido,
          hu_cedula: this.usuario.u_cedula,
          hu_cargo: this.usuario.u_cargo,
          hu_correo: this.usuario.u_correo,
          hu_telefono: this.usuario.u_telefono,
          hu_fecha_agregado: this.usuario.registro_fecha,
          hu_registrado_por: this.$store.state.email,
          hu_privilegios: this.usuario.u_privilegios,
          hu_estado: this.usuario.u_estado,
          hu_fecha_editado: this.hora_registro_historial,
        })
        .then(() => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Registrado correctamente.",
            showConfirmButton: false,
            timer: 1500,
          });
        });
    },

    // FUNCIÓN PARA MOSTRAR DATOS REGIONALES
    consultar_regional(id_usuario) {
      /* INICIAR LOADING */
      // this.$isLoading(true);
      let regional_existente = "";
      const queryRegional = db
        .collection("nuevo_regional")
        .orderBy("r_nueva_region", "asc");

      const queryUsuario = db.collection("usuarios").doc(id_usuario);
      queryUsuario.get().then((doc) => {
        if (doc.exists) {
          this.usuario.uid_usuario = doc.id;
          this.usuario.u_nombre_usuario = doc.data().u_nombre_usuario;
          this.usuario.u_apellido = doc.data().u_apellido;
        }
      });

      queryRegional.onSnapshot((querySnapshot) => {
        // LIMPIAR ARRAY ANTES DE CONSULTAR
        this.arrayRegionales = [];
        querySnapshot.forEach((doc) => {
          if (doc.data().r_nueva_region != regional_existente) {
            this.arrayRegionales.push({
              key: doc.id,
              regionalConsultada: doc.data().r_nueva_region,
            });
            regional_existente = doc.data().r_nueva_region;
          }
        });
        // LIMPIAR ARRAY ANTES DE CONSULTAR
        this.regional_general2 = [];
        querySnapshot.forEach((doc) => {
          if (doc.data().r_nueva_region != regional_existente) {
            this.regional_general2.push({
              key: doc.id,
              regionalConsultada: doc.data().r_nueva_region,
            });
            regional_existente = doc.data().r_nueva_region;
          }
        });
        // LIMPIAR ARRAY ANTES DE CONSULTAR
        this.regional_general2 = [];
        querySnapshot.forEach((doc) => {
          if (`${doc.data().r_nueva_region}` != regional_existente) {
            this.regional_general2.push({
              key: doc.id,
              regional_consulta: doc.data().r_nueva_region,
            });
            regional_existente = `${doc.data().r_nueva_region}`;
          }
        });
      });
      /* FINALIZAR LOADING */
      // this.$isLoading(false);
    },

    /* FUNCIÓN REGISTRO MODAL */
    datos_registro_modal(id_usuario) {
      const queryUsuario = db.collection("usuarios").doc(id_usuario);
      queryUsuario.get().then((doc) => {
        if (doc.exists) {
          this.usuario.uid_usuario = doc.id;
          this.usuario.u_nombre_usuario = doc.data().u_nombre_usuario;
          this.usuario.u_apellido = doc.data().u_apellido;
        }
        $("#privilegiosUsuariosRegistro").modal("show");
      });
    },

    async selectCliente() {
      if (
        this.u_privilegios_iper.m_administracion.registro_cliente.ver == false
      ) {
        this.u_privilegios_iper.m_administracion.registro_cliente.crear = true;
        this.u_privilegios_iper.m_administracion.registro_cliente.editar = true;
        this.u_privilegios_iper.m_administracion.registro_cliente.eliminar = true;
      } else if (
        this.u_privilegios_iper.m_administracion.registro_cliente.ver == true
      ) {
        this.u_privilegios_iper.m_administracion.registro_cliente.crear = false;
        this.u_privilegios_iper.m_administracion.registro_cliente.editar = false;
        this.u_privilegios_iper.m_administracion.registro_cliente.eliminar = false;
      }
    },
    async selectProceso() {
      if (
        this.u_privilegios_iper.m_administracion.registro_proceso.ver == false
      ) {
        this.u_privilegios_iper.m_administracion.registro_proceso.crear = true;
        this.u_privilegios_iper.m_administracion.registro_proceso.editar = true;
        this.u_privilegios_iper.m_administracion.registro_proceso.eliminar = true;
      } else if (
        this.u_privilegios_iper.m_administracion.registro_proceso.ver == true
      ) {
        this.u_privilegios_iper.m_administracion.registro_proceso.crear = false;
        this.u_privilegios_iper.m_administracion.registro_proceso.editar = false;
        this.u_privilegios_iper.m_administracion.registro_proceso.eliminar = false;
      }
    },
    async selectPeligro() {
      if (
        this.u_privilegios_iper.m_administracion.registro_peligro.ver == false
      ) {
        this.u_privilegios_iper.m_administracion.registro_peligro.crear = true;
        this.u_privilegios_iper.m_administracion.registro_peligro.editar = true;
        this.u_privilegios_iper.m_administracion.registro_peligro.eliminar = true;
      } else if (
        this.u_privilegios_iper.m_administracion.registro_peligro.ver == true
      ) {
        this.u_privilegios_iper.m_administracion.registro_peligro.crear = false;
        this.u_privilegios_iper.m_administracion.registro_peligro.editar = false;
        this.u_privilegios_iper.m_administracion.registro_peligro.eliminar = false;
      }
    },
    async selectControl() {
      if (
        this.u_privilegios_iper.m_administracion.registro_control_medida.ver ==
        false
      ) {
        this.u_privilegios_iper.m_administracion.registro_control_medida.crear = true;
        this.u_privilegios_iper.m_administracion.registro_control_medida.editar = true;
        this.u_privilegios_iper.m_administracion.registro_control_medida.eliminar = true;
      } else if (
        this.u_privilegios_iper.m_administracion.registro_control_medida.ver ==
        true
      ) {
        this.u_privilegios_iper.m_administracion.registro_control_medida.crear = false;
        this.u_privilegios_iper.m_administracion.registro_control_medida.editar = false;
        this.u_privilegios_iper.m_administracion.registro_control_medida.eliminar = false;
      }
    },
    async selectUsuario() {
      if (
        this.u_privilegios_iper.m_administracion.registro_usuario.ver == false
      ) {
        this.u_privilegios_iper.m_administracion.registro_usuario.crear = true;
        this.u_privilegios_iper.m_administracion.registro_usuario.editar = true;
        this.u_privilegios_iper.m_administracion.registro_usuario.eliminar = true;
      } else if (
        this.u_privilegios_iper.m_administracion.registro_usuario.ver == true
      ) {
        this.u_privilegios_iper.m_administracion.registro_usuario.crear = false;
        this.u_privilegios_iper.m_administracion.registro_usuario.editar = false;
        this.u_privilegios_iper.m_administracion.registro_usuario.eliminar = false;
      }
    },
    async selectRegionales() {
      if (
        this.u_privilegios_iper.m_administracion.registro_regionales.ver ==
        false
      ) {
        this.u_privilegios_iper.m_administracion.registro_regionales.crear = true;
        this.u_privilegios_iper.m_administracion.registro_regionales.editar = true;
        this.u_privilegios_iper.m_administracion.registro_regionales.eliminar = true;
      } else if (
        this.u_privilegios_iper.m_administracion.registro_regionales.ver == true
      ) {
        this.u_privilegios_iper.m_administracion.registro_regionales.crear = false;
        this.u_privilegios_iper.m_administracion.registro_regionales.editar = false;
        this.u_privilegios_iper.m_administracion.registro_regionales.eliminar = false;
      }
    },
    async selectMatrices() {
      if (this.u_privilegios_iper.m_matriz_peligro.ver == false) {
        this.u_privilegios_iper.m_matriz_peligro.crear = true;
        this.u_privilegios_iper.m_matriz_peligro.editar = true;
        this.u_privilegios_iper.m_matriz_peligro.eliminar = true;
        this.u_privilegios_iper.m_matriz_peligro.descargar_excel = true;
        this.u_privilegios_iper.m_matriz_peligro.copiar_matriz = true;
        this.u_privilegios_iper.m_matriz_peligro.consultar = true;
      } else if (this.u_privilegios_iper.m_matriz_peligro.ver == true) {
        this.u_privilegios_iper.m_matriz_peligro.crear = false;
        this.u_privilegios_iper.m_matriz_peligro.editar = false;
        this.u_privilegios_iper.m_matriz_peligro.eliminar = false;
        this.u_privilegios_iper.m_matriz_peligro.descargar_excel = false;
        this.u_privilegios_iper.m_matriz_peligro.copiar_matriz = false;
        this.u_privilegios_iper.m_matriz_peligro.consultar = false;
      }
    },

    // AGREGAR PRIVILEGIOS
    agregar_privilegio(id) {
      // console.log(id);
      /* INICIAR LOADING */
      // this.$isLoading(true);
      const privilegioCollection = db
        .collection("usuarios")
        .doc(id)
        .update({
          u_privilegios_iper: this.u_privilegios_iper,
          u_rango_fecha_fin: this.u_rango_fecha_fin,
          u_rango_fecha_inicio: this.u_rango_fecha_inicio,
          u_regionales_todas: this.u_regionales_todas,
        })
        .then(() => {})
        .catch((error) => {});
      this.editar_estado_privilegio(id);
      /* FINALIZAR LOADING */
      // this.$isLoading(false);
    },
    editar_estado_privilegio(id) {
      const privilegio_usuario = db.collection("usuarios").doc(id);
      return privilegio_usuario
        .update({
          u_privilegios: "1",
        })
        .then(() => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Guardado correctamente.",
            showConfirmButton: false,
            timer: 1500,
          });
        });
    },

    // FUNCIÓN PARA CONSULTAR USUARIO
    consultarUsuario(id_usuario) {
      /* INICIAR LOADING */
      // this.$isLoading(true);

      const readUser = db.collection("usuarios").doc(id_usuario);
      readUser.get().then((doc) => {
        if (doc.exists) {
          this.usuario = doc.data();
        }
      });
      /* FINALIZAR LOADING */
      // this.$isLoading(false);
      $("#editarusuario").modal("show");
    },

    // FUNCIÓN PARA EDITAR CLIENTE
    editar_usuario(key) {
      // console.log("hola");
      $("#editarusuario").modal("hide");

      // FUNCIÓN PARA EDITAR
      const editarUsuario = db.collection("usuarios").doc(key);
      return editarUsuario
        .update(this.usuario)
        .then(() => {
          this.usuario = [];
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Actualizado correctamente.",
            showConfirmButton: false,
            timer: 1500,
          });
        })
        .catch((error) => {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
        });
      /* FINALIZAR LOADING */
      // this.$isLoading(false);
    },
    async historialUsuarioEditado(id_usuario) {
      // console.log("entro a historial");
      this.hora_registro_historial = firebase.firestore.FieldValue.serverTimestamp();
      const newHistorial = db.collection("historial_usuario").doc();
      const id_historial = newHistorial.id;
      db.collection("historial_usuario")
        .doc(id_historial)
        .set({
          // DATOS DEL CLIENTE
          hu_idHisotrial: id_historial,
          hu_id_usuario: id_usuario,
          hu_nombre_usuario: this.usuario.u_nombre_usuario,
          hu_apellido: this.usuario.u_apellido,
          hu_cedula: this.usuario.u_cedula,
          hu_cargo: this.usuario.u_cargo,
          hu_correo: this.usuario.u_correo,
          hu_telefono: this.usuario.u_telefono,
          hu_fecha_agregado: this.usuario.registro_fecha,
          hu_registrado_por: this.$store.state.email,
          hu_privilegios: this.usuario.u_privilegios,
          hu_estado: this.usuario.u_estado,
          hu_fecha_editado: this.hora_registro_historial,
        })
        .then(() => {});
      this.editar_usuario(id_usuario);
    },

    vaciasVariables() {
      this.usuario = [];
    },

    // FUNCIÓN PARA MOSTRAR DATOS PRIVILEGIO
    consultar_privilegios(id_usuario) {
      // console.log("entro");
      let regional_existente = "";
      this.regionales_seleccionadas =
        "usuarios/" + id_usuario + "/u_test_regional";

      const query01 = db.collection("usuarios").doc(id_usuario);
      const query02 = db
        .collection("nuevo_regional")
        .orderBy("r_nueva_region", "asc");
      const query03 = db
        .collection(this.regionales_seleccionadas)
        .orderBy("nombre_regional", "asc");

      query01.get().then((doc) => {
        if (doc.exists) {
          this.usuario.uid_usuario = doc.data().uid_usuario;
          this.u_privilegios_iper = doc.data().u_privilegios_iper;
          this.u_matrices_regional = doc.data().u_matrices_regional;
          this.u_rango_fecha_fin = doc.data().u_rango_fecha_fin;
          this.u_rango_fecha_inicio = doc.data().u_rango_fecha_inicio;
          this.u_regionales_todas = doc.data().u_regionales_todas;
        }
      });

      query02.onSnapshot((querySnapshot) => {
        // LIMPIAR ARRAY ANTES DE CONSULTAR
        this.arrayRegionales1 = [];
        querySnapshot.forEach((doc) => {
          if (doc.data().r_nueva_region != regional_existente) {
            this.arrayRegionales1.push({
              key: doc.id,
              regionalConsultada: doc.data().r_nueva_region,
            });
            regional_existente = doc.data().r_nueva_region;
          }
        });
        // LIMPIAR ARRAY ANTES DE CONSULTAR
        this.regional_general2 = [];
        querySnapshot.forEach((doc) => {
          if (`${doc.data().r_nueva_region}` != regional_existente) {
            this.regional_general2.push({
              key: doc.id,
              regionalConsultada: doc.data().r_nueva_region,
            });
            regional_existente = doc.data().r_nueva_region;
          }
        });
        // LIMPIAR ARRAY ANTES DE CONSULTAR
        this.regional_general2 = [];
        querySnapshot.forEach((doc) => {
          if (`${doc.data().r_nueva_region}` != regional_existente) {
            this.regional_general2.push({
              key: `${doc.id}`,
              regional_consulta: doc.data().r_nueva_region,
            });
            regional_existente = doc.data().r_nueva_region;
          }
        });
      });

      query03.onSnapshot((querySnapshot) => {
        // LIMPIAR ARRAY ANTES DE CONSULTAR
        this.regionales1 = [];
        querySnapshot.forEach((doc) => {
          this.regionales1.push({
            id: doc.id,
            regionales_select: doc.data().nombre_regional,
          });
        });
      });
    },

    // EDITAR PRIVILEGIOS
    editar_privilegio() {
      // console.log(this.usuario.uid_usuario);
      /* INICIAR LOADING */
      // this.$isLoading(true);

      // FUNCIÓN PARA EDITAR
      db.collection("usuarios")
        .doc(this.usuario.uid_usuario)
        .update({
          u_privilegios_iper: this.u_privilegios_iper,
          u_rango_fecha_fin: this.u_rango_fecha_fin,
          u_rango_fecha_inicio: this.u_rango_fecha_inicio,
          u_regionales_todas: this.u_regionales_todas,
        })
        .then(() => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Actualizado correctamente.",
            showConfirmButton: false,
            timer: 1500,
          });
        })
        .catch((error) => {});
      $("#privilegios_editar").modal("hide");
      /* FINALIZAR LOADING */
      // this.$isLoading(false);
    },

    // FUNCIÓN PARA CONSULTAR ID USUARIO
    consultar_id_cliente(id_usuario) {
      const readId = db.collection("usuarios").doc(id_usuario);
      readId.get().then((doc) => {
        if (doc.exists) {
          this.usuario = doc.data();
        }
      });
    },

    // HISTORIAL DEL CLIENTE CON ESTADO SIN SERVICIO
    historial_usuario_estado(uid) {
      // console.log("entro a historial");
      this.hora_registro_historial = firebase.firestore.FieldValue.serverTimestamp();
      const newHistorial = db.collection("historial_usuario").doc();
      const id_historial = newHistorial.id;
      db.collection("historial_usuario")
        .doc(id_historial)
        .set({
          // DATOS DEL CLIENTE
          hu_idHisotrial: id_historial,
          hu_id_usuario: uid,
          hu_nombre_usuario: this.usuario.u_nombre_usuario,
          hu_apellido: this.usuario.u_apellido,
          hu_cedula: this.usuario.u_cedula,
          hu_cargo: this.usuario.u_cargo,
          hu_correo: this.usuario.u_correo,
          hu_telefono: this.usuario.u_telefono,
          hu_fecha_agregado: this.usuario.registro_fecha,
          hu_registrado_por: this.$store.state.email,
          hu_privilegios: this.usuario.u_privilegios,
          hu_estado: this.usuario.u_estado,
          hu_fecha_editado: this.hora_registro_historial,
        })
        .then(() => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Registrado correctamente.",
            showConfirmButton: false,
            timer: 1500,
          });
        });
      this.editar_estado(uid);
      $("#estado_usuario").modal("hide");
    },

    // ESTADO NO ACTIVO
    editar_estado(uid) {
      const privilegio_usuario = db.collection("usuarios").doc(uid);
      return privilegio_usuario
        .update({
          u_estado: "1",
        })
        .then(() => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Usuario no activo.",
            showConfirmButton: false,
            timer: 1500,
          });
        });
    },

    // HISTORIAL DEL CLIENTE CON ESTADO SIN SERVICIO
    historial_usuario_estado1(uid) {
      // console.log("entro a historial");
      this.hora_registro_historial = firebase.firestore.FieldValue.serverTimestamp();
      const newHistorial = db.collection("historial_usuario").doc();
      const id_historial = newHistorial.id;
      db.collection("historial_usuario")
        .doc(id_historial)
        .set({
          // DATOS DEL CLIENTE
          hu_idHisotrial: id_historial,
          hu_id_usuario: uid,
          hu_nombre_usuario: this.usuario.u_nombre_usuario,
          hu_apellido: this.usuario.u_apellido,
          hu_cedula: this.usuario.u_cedula,
          hu_cargo: this.usuario.u_cargo,
          hu_correo: this.usuario.u_correo,
          hu_telefono: this.usuario.u_telefono,
          hu_fecha_agregado: this.usuario.registro_fecha,
          hu_registrado_por: this.$store.state.email,
          hu_privilegios: this.usuario.u_privilegios,
          hu_estado: this.usuario.u_estado,
          hu_fecha_editado: this.hora_registro_historial,
        })
        .then(() => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Registrado correctamente.",
            showConfirmButton: false,
            timer: 1500,
          });
        });
      this.editar_estado_activo(uid);
      $("#estado_usuario2").modal("hide");
    },

    // ESTADO ACTIVO
    editar_estado_activo(uid) {
      const privilegio_usuario = db.collection("usuarios").doc(uid);
      return privilegio_usuario
        .update({
          u_estado: "0",
        })
        .then(() => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Usuario activo.",
            showConfirmButton: false,
            timer: 1500,
          });
        });
    },

    editar_historial_usuario() {
      (this.hora_registro_historial = firebase.firestore.FieldValue.serverTimestamp()),
        // FIN DE LA EXTRACCIÓN DE LA FECHA Y HORA ACTUAL

        db
          .collection("historial_usuario")
          .add({
            hu_idHisotrial: id_historial,
            hu_id_usuario: id_usuario,
            hu_nombre_usuario: this.usuario.u_nombre_usuario,
            hu_apellido: this.usuario.u_apellido,
            hu_cedula: this.usuario.u_cedula,
            hu_cargo: this.usuario.u_cargo,
            hu_correo: this.usuario.u_correo,
            hu_telefono: this.usuario.u_telefono,
            hu_fecha_agregado: this.usuario.registro_fecha,
            hu_registrado_por: this.$store.state.email,
            hu_privilegios: this.usuario.u_privilegios,
            hu_estado: this.usuario.u_estado,
            hu_fecha_editado: this.hora_registro_historial,
          })
          .then(() => {});
      this.editar_usuario(con_key);
    },

    // FUNCIÓN PARA MOSTRAR DATOS DEL HISTORIAL
    consultar_historial(key_usuario) {
      this.array_historial = [];
      db.collection("historial_usuario")
        .orderBy("hu_fecha_editado", "asc")
        .where("hu_id_usuario", "==", key_usuario)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // FECHA REGISTRO
            let fechaHistorial = doc.data().hu_fecha_editado.toData;
            fechaHistorial = moment(fechaHistorial).format("DD/MM/YYYY");
            let fechaRegistro = doc.data().hu_fecha_agregado.toData;
            fechaRegistro = moment(fechaRegistro).format("DD/MM/YYYY");
            this.array_historial.push({
              id_historial: doc.id,
              usuario: doc.data().hu_nombre_usuario,
              apellido: doc.data().hu_apellido,
              cargo: doc.data().hu_cargo,
              cedula: doc.data().hu_cedula,
              correo: doc.data().hu_correo,
              celular: doc.data().hu_telefono,
              privilegios: doc.data().hu_privilegios,
              estado: doc.data().hu_estado,
              creado_por: doc.data().hu_registrado_por,
              fecha_historial: fechaHistorial,
              fecha_registro: fechaRegistro,
            });
          });
        });
    },

    // FUNCIÓN PARA MOSTRAR LOS DEPARTAMENTOS
    departamentos_select() {
      if (this.regionales_list != "") {
        var query02 = db
          .collection("nuevo_regional")
          .where("r_nueva_region", "==", this.regionales_list);
        query02.onSnapshot((querySnapshot) => {
          // LIMPIAR ARRAY ANTES DE CONSULTAR
          this.departamento_general = [];
          querySnapshot.forEach((doc) => {
            this.departamento_general.push({
              regional_select: doc.data().r_nueva_region,
              departamento_list: doc.data().r_departamento,
              // AQUÍ SE AGREGÓ LA PROPIEDAD CHECKED
              checked: false,
            });
          });
        });
      }
    },

    departamentos_editar() {
      this.departamento_list_editar = "";
      if (this.regionales_list != "") {
        var query02 = db
          .collection("nuevo_regional")
          .where("r_nueva_region", "==", this.regionales_list)
          .orderBy("r_departamento", "asc");
        query02.get().then((doc) => {
          // LIMPIAR ARRAY ANTES DE CONSULTAR
          this.departamento_general_editar = [];
          doc.forEach((doc) => {
            this.departamento_general_editar.push({
              regional_select: doc.data().r_nueva_region,
              departamento_list_editar: doc.data().r_departamento,
            });
          });
        });
        this.query_reg(this.regionales_list);
      }
    },

    query_reg(regional_) {
      this.lista_departamentos = [];
      this.lista_municipios = [];
      this.query_regional = "usuarios/" + this.p_key + "/u_test_regional";
      let query02 = db
        .collection(this.query_regional)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.array_reg_edit.push(doc.data());
          });

          // LLAMA LOS DEPARTAMENTOS DEL USUARIO
          this.array_reg_edit.forEach((x) => {
            if (x.nombre_regional == regional_) {
              (this.id_regionales = x.id_regional),
                x.departamentos.forEach((y) => {
                  // LLAMAR LOS MUNICIPIOS DEL USUARIO
                  this.lista_departamentos.push(y.nombre_departamento);
                  y.municipios.forEach((z) => {
                    this.lista_municipios.push(z);
                  });
                });
            }
            this.municipio_consulta(this.lista_departamentos);
          });
        });
    },

    // FUNCIÓN PARA MOSTRAR LOS MUNICIPIOS
    municipio_departamento() {
      // AQUÍ FILTRO DE LOS DEPARTAMENTOS QUE TIENEN LA PROPIEDAD CHECKED EN TRUE
      const departamentos_seleccionados = this.departamento_general.filter(
        (departamento) => departamento.checked
      );
      if (departamentos_seleccionados.length > 0) {
        const departamentos = departamentos_seleccionados.map(
          (departamento) => departamento.departamento_list
        );

        const docRef = db
          .collection("nuevo_regional")
          .where("r_departamento", "in", departamentos)
          .orderBy("r_municipios", "asc");
        docRef.onSnapshot((querySnapshot) => {
          // ASIGNO LOS VIEJOS DATOS A ESTA VARIABLE PARA QUE NO SE ME PIERDAN LOS MUNICIPIOS CHECKEADOS
          const old_municipios_general = this.municipio_general || [];
          // LIMPIAR ARRAY ANTES DE CONSULTAR
          this.municipio_general = [];
          querySnapshot.forEach((doc) => {
            if (`${doc.data().r_nueva_region}` == this.regionales_list) {
              this.municipio_general.push({
                departamento_select: doc.data().r_departamento,
                municipio_list: doc.data().r_municipios,
              });
            }
          });
          // AQUÍ MAPEO LA LISTA DE DEPARTAMENTOS CON MUNICIPIOS PARA CONVERTIR EL ARRAY DE STRING DE MUNICIPIO
          // A UN ARRAY DE OBJETOS DE MUNICIPIOS
          this.municipio_general = this.municipio_general.map(
            (departamento) => {
              const old_departamentos = old_municipios_general.filter(
                (old_departamento) =>
                  old_departamento.departamento_select ===
                  departamento.departamento_select
              );

              const municipios = departamento.municipio_list.map(
                (municipio) => {
                  let checked = false;

                  if (old_departamentos.length > 0) {
                    const old_municipio = old_departamentos[0].municipio_list.filter(
                      (old_municipio) => old_municipio.nombre === municipio
                    );
                    checked = old_municipio[0].checked;
                  }

                  const municipio_object = {
                    nombre: municipio,
                    checked,
                  };
                  return municipio_object;
                }
              );
              return {
                departamento_select: departamento.departamento_select,
                municipio_list: municipios,
              };
            }
          );
        });
      }
    },

    municipio_consulta(lista_departamentos) {
      // AQUÍ FILTRO LOS DEPARTAMENTOS QUE TIENEN LA PROPIEDAD CHECKED EN TRUE
      // const departamentos_seleccionados = this.departamento_general_editar.filter(departamento => departamento.checked)
      if (lista_departamentos.length > 0) {
        // const departamentos = lista_departamentos.map(departamento => departamento.departamento_list_editar)
        const docRef = db
          .collection("nuevo_regional")
          .where("r_departamento", "in", lista_departamentos)
          .orderBy("r_municipios", "asc");
        docRef.onSnapshot((querySnapshot) => {
          // ASIGNO LOS VIEJOS DATOS A ESTA VARIBALE PARA QUE NO SE ME PIERDAN LOS MUNICIPIOS CHECKED
          const old_municipios_general = this.municipio_general || [];
          // LIMPIAR ARRAY ANTES DE CONSULTAR
          this.municipio_general = [];
          querySnapshot.forEach((doc) => {
            if (`${doc.data().r_nueva_region}` == this.regionales_list) {
              this.municipio_general.push({
                departamento_select: doc.data().r_departamento,
                municipio_list_editar: doc.data().r_municipios,
              });
            }
          });
          // AQUÍ MAPEO LAS LISTAS DE DEPARTAMENTOS CON MUNICIPIOS PARA CONVERTIR EL ARRAY DE STRING DE MUNICIPIO
          // A UN ARRAY DE OBJETOS DE MUNICIPIOS
          this.municipio_general = this.municipio_general.map(
            (departamento) => {
              const old_departamentos = old_municipios_general.filter(
                (old_departamento) =>
                  old_departamento.departamento_select ===
                  departamento.departamento_select
              );

              const municipios = departamento.municipio_list_editar.map(
                (municipio) => {
                  if (old_departamentos.length > 0) {
                    const old_municipio = old_departamentos[0].municipio_list_editar.filter(
                      (old_municipio) => old_municipio.nombre === municipio
                    );
                  }

                  const municipio_object = {
                    nombre: municipio,
                  };
                  return municipio_object;
                }
              );
              return {
                departamento_select: departamento.departamento_select,
                municipio_list_editar: municipios,
              };
            }
          );
        });
      }
    },

    // ELIMINAR USUARIO
    eliminar_usuario(id_usuario) {
      Swal.fire({
        title: "¿Seguro que desea eliminar este usuario?",
        text: "¡Una vez eliminado, no podrás volver a ver el usuario!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, Eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          db.collection("usuarios")
            .doc(id_usuario)
            .delete()
            .then(() => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "Datos eliminados satisfactoriamente.",
                showConfirmButton: false,
                timer: 1500,
                allowOutsideClick: false,
                allowEscapeKey: false,
              });
            });
        }
      });
    },

    // FILTRO DEPARTAMENTO
    filtro_departa(departamento_lista, regional_) {
      return departamento_lista.filter(
        (departamento) => departamento.regional_select === regional_
      );
    },

    filtro_municipio(municipio_lista, departamento_) {
      if (municipio_lista.length > 0) {
        const municipios = municipio_lista.filter(
          (muni) => muni.departamento_select === departamento_
        );
        if (municipios.length > 0) {
          return municipios[0].municipio_list;
        } else {
          return [];
        }
      } else {
        return [];
      }
    },

    filtro_municipio_editar(municipio_lista, departamento_) {
      if (municipio_lista.length > 0) {
        const municipios = municipio_lista.filter(
          (muni) => muni.departamento_select === departamento_
        );
        if (municipios.length > 0) {
          return municipios[0].municipio_list_editar;
        } else {
          return [];
        }
      } else {
        return [];
      }
    },

    async consultarRegionales() {
      /* INICIAR LOADING */
      // this.$isLoading(true);

      // CONSULTA GLOBAL - GUARDAR REGIONALES EN EL USUARIO
      let regionalesGlobales = await this.regionalesGlobales();

      let consultarRegionalesCompletas = await this.consultarRegionalesCompletas();

      consultarRegionalesCompletas.forEach((doc) => {
        regionalesGlobales.forEach((regional) => {
          if (regional.nombre_regional == doc.nombre_regional) {
            regional.departamentos.push({
              nombre_departamento: doc.nombre_departamento,
              municipios: doc.municipios,
            });
          }
        });
      });
      for (let index = 0; index < regionalesGlobales.length; index++) {
        const element = regionalesGlobales[index];

        this.regionales_sub =
          "usuarios/" + this.usuario.uid_usuario + "/u_test_regional";
        const newClienteRef = db.collection(this.regionales_sub).doc();
        const id = newClienteRef.id;
        const update_reg = db.collection(this.regionales_sub).doc(id);
        update_reg
          .set({
            nombre_regional: element.nombre_regional,
            departamentos: element.departamentos,
            id_regional: id,
          })
          .catch(function(error) {
            console.error("Error adding document: ", error);
          });
      }
      /* FINALIZAR LOADING */
      // this.$isLoading(false);
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Agregado correctamente.",
        showConfirmButton: false,
        timer: 1500,
      });
      $("#privilegiosUsuarios").modal("hide");
    },

    async regionalesGlobales() {
      let traerRegionalesGlobales = db
        .collection("nuevo_regional")
        .get()
        .then((querySnapshot) => {
          let arryRegionales = [];
          querySnapshot.forEach((doc) => {
            arryRegionales.push({
              nombre_regional: doc.data().r_nueva_region,
              departamentos: [],
            });
          });
          // DEVOLVER SOLO DATOS ÚNICOS, NO REPETIDOS
          let set = new Set(arryRegionales.map(JSON.stringify));
          arryRegionales = Array.from(set).map(JSON.parse);
          return arryRegionales;
        });
      return traerRegionalesGlobales;
    },

    async consultarRegionalesCompletas(regionalesGlobales) {
      let traerRegionalesCompletas = db
        .collection("nuevo_regional")
        .get()
        .then((querySnapshot) => {
          let arryRegionalesCompleto = [];
          querySnapshot.forEach((doc) => {
            arryRegionalesCompleto.push({
              nombre_departamento: doc.data().r_departamento,
              municipios: doc.data().r_municipios,
              nombre_regional: doc.data().r_nueva_region,
            });
          });
          return arryRegionalesCompleto;
        });
      return traerRegionalesCompletas;
    },

    // AGREGAR REGIONALES EN LA SUBCOLECCIÓN DE CADA USUARIO
    async add_reg() {
      /* INICIAR LOADING */
      // this.$isLoading(true);

      this.regionales_sub = "usuarios/" + this.con_key + "/u_test_regional";
      if (this.todos_departamentos) {
        // CONSULTA GLOBAL - GUARDAR REGIONALES EN EL USUARIO
        let consultarRegionalesGlobales = await this.consultarRegionalesGlobales();

        let consultarDepartamentos = await this.consultarDepartamentos();

        consultarDepartamentos.forEach((doc) => {
          consultarRegionalesGlobales.forEach((regional) => {
            if (regional.nombre_regional == doc.nombre_regional) {
              regional.departamentos.push({
                nombre_departamento: doc.nombre_departamento,
                municipios: doc.municipios,
              });
            }
          });
        });

        const newClienteRef = db.collection(this.regionales_sub).doc();
        const id = newClienteRef.id;

        const update_reg = db.collection(this.regionales_sub).doc(id);
        update_reg.set({
          id_regional: id,
          nombre_regional: this.regionales_list,
          departamentos: consultarDepartamentos,
        });
      }
      if (this.todos_municipios) {
      } else {
        const newClienteRef = db.collection(this.regionales_sub).doc();
        const id = newClienteRef.id;

        const update_reg = db.collection(this.regionales_sub).doc(id);
        const departamentosSelected = this.municipio_general.map(
          (departamento) => {
            const municipios = departamento.municipio_list
              .filter((municipio) => municipio.checked)
              .map((municipio) => municipio.nombre);
            return {
              nombre_departamento: departamento.departamento_select,
              municipios: municipios,
            };
          }
        );
        update_reg.set(
          {
            id_regional: id,
            nombre_regional: this.regionales_list,
            departamentos: departamentosSelected,
          },
          { merge: true }
        );
      }
      (this.regional = ""),
        (this.regionales_list = ""),
        (this.todos_departamentos = ""),
        (this.municipio_general = []);
      this.departamento_general = [];

      /* FINALIZAR LOADING */
      // this.$isLoading(false);
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Agregado correctamente.",
        showConfirmButton: false,
        timer: 1500,
      });
    },

    async consultarDepartamentos(consultarRegionalesGlobales) {
      let traerRegionalesCompletas = db
        .collection("nuevo_regional")
        .where("r_nueva_region", "==", this.regionales_list)
        .get()
        .then((querySnapshot) => {
          let arryRegionalesCompleto = [];
          querySnapshot.forEach((doc) => {
            arryRegionalesCompleto.push({
              nombre_departamento: doc.data().r_departamento,
              municipios: doc.data().r_municipios,
            });
          });
          return arryRegionalesCompleto;
        });
      return traerRegionalesCompletas;
    },

    // EDITAR REGIONALES EN LA SUBCOLECCIÓN DE CADA USUARIO
    async consultarUsuario(id_usuario) {
      // CONSULTA GLOBAL - GUARDAR REGIONALES EN EL USUARIO
      let consultarRegionalesGlobales = await this.consultarRegionalesGlobales();

      let consultarRegionalesCompletas = await this.consultarRegionalesCompletas();

      consultarRegionalesCompletas.forEach((doc) => {
        consultarRegionalesGlobales.forEach((regional) => {
          if (regional.nombre_regional == doc.nombre_regional) {
            regional.departamentos.push({
              nombre_departamento: doc.nombre_departamento,
              municipios: doc.municipios,
            });
          }
        });
      });

      let arrayUpdate = [];
      // FIN CONSULTA GLOBAL - GUARDAR REGIONALES EN EL USUARIO
      consultarRegionalesGlobales.forEach((regionalGlobal) => {
        if (this.regionales_list == regionalGlobal.nombre_regional) {
          arrayUpdate.push({
            nombre_regional: regionalGlobal.nombre_regional,
            departamentos: [],
          });
          regionalGlobal.departamentos.forEach((departamentosGlobales) => {
            this.lista_departamentos.forEach((departamentosSeleccionados) => {
              if (
                departamentosSeleccionados ==
                departamentosGlobales.nombre_departamento
              ) {
                arrayUpdate.forEach((depts) => {
                  if (depts.nombre_regional == regionalGlobal.nombre_regional) {
                    depts.departamentos.push({
                      nombre_departamento:
                        departamentosGlobales.nombre_departamento,
                      municipios: [],
                    });
                  }
                });
                departamentosGlobales.municipios.forEach(
                  (municipiosGlobales) => {
                    this.lista_municipios.forEach((municipiosSeleccionados) => {
                      if (municipiosSeleccionados == municipiosGlobales) {
                        arrayUpdate.forEach((muni) => {
                          if (
                            muni.nombre_regional ==
                            regionalGlobal.nombre_regional
                          ) {
                            muni.departamentos.forEach((filtroMunicipio) => {
                              if (
                                filtroMunicipio.nombre_departamento ==
                                departamentosGlobales.nombre_departamento
                              ) {
                                filtroMunicipio.municipios.push(
                                  municipiosGlobales
                                );
                              }
                            });
                          }
                        });
                      }
                    });
                  }
                );
              }
            });
          });
        }
      });

      this.regionales_sub = "usuarios/" + this.p_key + "/u_test_regional";
      db.collection(this.regionales_sub)
        .doc(this.id_regionales)
        .set({
          nombre_regional: arrayUpdate[0].nombre_regional,
          departamentos: arrayUpdate[0].departamentos,
          id_regional: this.id_regionales,
        });

      this.regionales_list = [];
      this.departamento_general_editar = [];
      this.lista_departamentos = [];
      this.municipio_general = [];
      this.lista_municipios = [];

      Swal.fire({
        position: "center",
        icon: "success",
        title: "Editado correctamente.",
        showConfirmButton: false,
        timer: 1500,
      });
    },

    async consultarIdRegionales(query_regional) {
      let traerIdRegionales = db
        .collection(query_regional)
        .get()
        .then((querySnapshot) => {
          let array_reg_edit = [];
          querySnapshot.forEach((doc) => {
            array_reg_edit.push({
              key: `${doc.id}`,
              nombre_regional: doc.data().nombre_regional,
              departamentos: doc.data().departamentos,
              checked: false,
            });
          });
          return array_reg_edit;
        });
      return traerIdRegionales;
    },

    async consultarRegionalesGlobales() {
      let traerRegionalesGlobales = db
        .collection("nuevo_regional")
        .get()
        .then((querySnapshot) => {
          let arryRegionales = [];
          querySnapshot.forEach((doc) => {
            arryRegionales.push({
              nombre_regional: doc.data().r_nueva_region,
              departamentos: [],
            });
          });
          // DEVOLVER SÓLO DATOS ÚNICOS, NO REPETIDOS
          let set = new Set(arryRegionales.map(JSON.stringify));
          arryRegionales = Array.from(set).map(JSON.parse);
          return arryRegionales;
        });
      return traerRegionalesGlobales;
    },

    async consultarRegionalesCompletas(consultarRegionalesGlobales) {
      let traerRegionalesCompletas = db
        .collection("nuevo_regional")
        .get()
        .then((querySnapshot) => {
          let arryRegionalesCompleto = [];
          querySnapshot.forEach((doc) => {
            arryRegionalesCompleto.push({
              nombre_departamento: doc.data().r_departamento,
              municipios: doc.data().r_municipios,
              nombre_regional: doc.data().r_nueva_region,
            });
          });
          return arryRegionalesCompleto;
        });
      return traerRegionalesCompletas;
    },
    // FIN CONSULTA REGIONAL - PRIVILEGIOS

    async obtenerMatriz(idCentroTrabajo) {
      let matriz = null;
      let obtenerMatriz = await db
        .collection("cliente_empresa")
        .doc(idCentroTrabajo)
        .get()
        .then((doc) => {
          matriz = {
            id: `${doc.id}`,
            centroTrabajo: `${doc.data().em_trabajo}`,
            ciudad: `${doc.data().em_ciudad}`,
            departamento: `${doc.data().em_departamento}`,
            regional: `${doc.data().em_regional}`,
          };
        })
        .catch((error) => {
          console.log("Error al obtener documento:", error);
        });
      return matriz;
    },

    async auditoriaUsuarioConsulta(correoUsuario) {
      this.data_historial_consulta = [];
      db.collection("historial_consulta")
        .where("correoUsuario", "==", correoUsuario)
        .orderBy("registro.creacion", "desc")
        .onSnapshot(
          (snapshot) => {
            snapshot.docChanges().forEach((change) => {
              let registro = change.doc.data().registro.creacion;
              try {
                registro = registro.toDate();
              } catch (error) {}
              registro = moment(registro).format("DD/MM/YYYY");
              let centroTrabajo = null;
              let ciudad = null;
              let departamento = null;
              let regional = null;
              (async () => {
                let idCentroTrabajo = change.doc.data().idCentroTrabajo;
                let obtenerMatriz = null;
                if (idCentroTrabajo && idCentroTrabajo != "") {
                  obtenerMatriz = await this.obtenerMatriz(idCentroTrabajo);
                }
                if (obtenerMatriz) {
                  centroTrabajo = obtenerMatriz.centroTrabajo;
                  ciudad = obtenerMatriz.ciudad;
                  departamento = obtenerMatriz.departamento;
                  regional = obtenerMatriz.regional;
                }
                if (change.type === "added") {
                  this.data_historial_consulta.unshift({
                    id: `${change.doc.id}`,
                    centroTrabajo: centroTrabajo,
                    ciudad: ciudad,
                    departamento: departamento,
                    regional: regional,
                    registro: registro,
                  });
                }
                if (change.type === "modified") {
                  this.data_historial_consulta.forEach((matriz) => {
                    if (matriz.id == change.doc.id) {
                      matriz.centroTrabajo = centroTrabajo;
                      matriz.ciudad = ciudad;
                      matriz.departamento = departamento;
                      matriz.regional = regional;
                      matriz.registro = registro;
                    }
                  });
                }
              })();
              if (change.type === "removed") {
                this.data_historial_consulta.forEach((matriz, index) => {
                  if (matriz.id == change.doc.id) {
                    this.data_historial_consulta.splice(index, 1);
                  }
                });
              }
              let set = new Set(
                this.data_historial_consulta.map(JSON.stringify)
              );
              this.data_historial_consulta = Array.from(set).map(JSON.parse);
            });
          },
          (error) => {
            console.log(
              "Error al obtener las actualizaciones en tiempo real para matriz.",
              error
            );
          }
        );
    },

    async auditoriaUsuarioDescarga(correoUsuario) {
      this.data_historial_descarga = [];
      db.collection("historial_descarga")
        .where("correoUsuario", "==", correoUsuario)
        .orderBy("registro.creacion", "desc")
        .onSnapshot(
          (snapshot) => {
            snapshot.docChanges().forEach((change) => {
              let registro = change.doc.data().registro.creacion;
              try {
                registro = registro.toDate();
              } catch (error) {}
              registro = moment(registro).format("DD/MM/YYYY");
              let centroTrabajo = null;
              let ciudad = null;
              let departamento = null;
              let regional = null;
              (async () => {
                let idCentroTrabajo = change.doc.data().idCentroTrabajo;
                let obtenerMatriz = null;
                if (idCentroTrabajo && idCentroTrabajo != "") {
                  obtenerMatriz = await this.obtenerMatriz(idCentroTrabajo);
                }
                if (obtenerMatriz) {
                  centroTrabajo = obtenerMatriz.centroTrabajo;
                  ciudad = obtenerMatriz.ciudad;
                  departamento = obtenerMatriz.departamento;
                  regional = obtenerMatriz.regional;
                }
                if (change.type === "added") {
                  this.data_historial_descarga.unshift({
                    id: `${change.doc.id}`,
                    centroTrabajo: centroTrabajo,
                    ciudad: ciudad,
                    departamento: departamento,
                    regional: regional,
                    registro: registro,
                  });
                }
                if (change.type === "modified") {
                  this.data_historial_descarga.forEach((matriz) => {
                    if (matriz.id == change.doc.id) {
                      matriz.centroTrabajo = centroTrabajo;
                      matriz.ciudad = ciudad;
                      matriz.departamento = departamento;
                      matriz.regional = regional;
                      matriz.registro = registro;
                    }
                  });
                }
              })();
              if (change.type === "removed") {
                this.data_historial_descarga.forEach((matriz, index) => {
                  if (matriz.id == change.doc.id) {
                    this.data_historial_descarga.splice(index, 1);
                  }
                });
              }
              let set = new Set(
                this.data_historial_descarga.map(JSON.stringify)
              );
              this.data_historial_descarga = Array.from(set).map(JSON.parse);
            });
          },
          (error) => {
            console.log(
              "Error al obtener las actualizaciones en tiempo real para matriz.",
              error
            );
          }
        );
    },
  },
};
</script>
